var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurrent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.77,
    height: 28.056,
    viewBox: "0 0 24.77 28.056",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.77,
    height: 28.056,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(6006.722 1303.966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560",
    transform: "translate(171.054 57.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(-6177.676 -1361.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_716",
    "data-name": "Path 716",
    d: "M70.933,221.234l-.372-.37c-5.487-.5-9.569-5.626-9.569-11.819a11.936,11.936,0,0,1,7.474-11.04l.072-.479a12.36,12.36,0,0,0-7.967,11.519C60.571,215.5,64.58,220.7,70.933,221.234Z",
    transform: "translate(-60.571 -193.554)",
    fill: "none",
    stroke: "#275d97",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_717",
    "data-name": "Path 717",
    d: "M101.647,208.26a11.943,11.943,0,0,1-11.771,11.963l-.3.42c.059,0,.118,0,.178,0a12.393,12.393,0,0,0,2.3-24.555l-.107.409A11.964,11.964,0,0,1,101.647,208.26Z",
    transform: "translate(-77.496 -192.692)",
    fill: "none",
    stroke: "#275d97",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M83.46,200.805l-1,5.24-2.139-2.053,1.126,9.165,5.662-7.512-2.84.839,3.059-10.323-5.881,2.251,2.6-9.852-4.81-.99-2.484,16.69ZM79.7,188.4l1.137.169-2.719,13.8,6.319-3.1.292-.143-.066.312-1.719,8.142,1.356-7.881-6.438,3.469-.51.275.076-.586Z",
    transform: "translate(-69.738 -187.571)",
    fill: "#275d97"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrent);
export default __webpack_public_path__ + "static/media/current.70be8079.svg";
export { ForwardRef as ReactComponent };